
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { links } from '@/configs/links';
import { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

@Component
export default class RampFooterV extends Vue {
    links = links;
    name = '';
    email = '';
    details = '';

    formError: Record<string, boolean> = {
        details: false,
        email: false,
        name: false
    };

    validated = false;
    sending = false;
    sent = false;

    get invalidEmail() {
        return this.email && !this.isEmailValid(this.email);
    }

    async sendEmail() {
        var error = false;
        this.validated = true;

        const data: Record<string, string> = {
            name: this.name,
            email: this.email,
            details: this.details
        };

        const fields: string[] = ['name', 'email', 'details'];

        fields.forEach((field: string) => {
            if (!data[field]) {
                error = true;
                this.formError[field] = true;
            }
        });

        if (!error && !this.invalidEmail) {
            try {
                this.sending = true;
                await axios
                    .post(
                        'https://rampmarketingapp.azurewebsites.net/api/SendEmail?code=GtVWNX3MATbZy54Ie-8Wlb5aCELpDn0TuzxQM5JZRWbjAzFuY9sM9w==',
                        data
                    )
                    .then((result) => {
                        if (result.status === 200) {
                            this.$toast.success(this.$t('contact.success'), {
                                position: POSITION.BOTTOM_CENTER,
                                timeout: 3000,
                                closeOnClick: true
                            });
                            this.sent = true;
                            this.sending = false;
                        }
                    });
            } catch (error) {
                this.sending = false;
                this.$toast.error(this.$t('contact.error'), {
                    position: POSITION.BOTTOM_CENTER,
                    timeout: 3000,
                    closeOnClick: true
                });
            }
        }
    }

    isEmailValid(email: string): boolean {
        const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
}
